import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../auth/auth-state.service';
import { AuthService } from '../auth/auth.service';

export const guestGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authState.isAuthenticated()) {
    return router.createUrlTree(['/app/smartfreight/rates']);
  }

  if (authState.requiresTwoFactor() && authService.hasPendingMfaSession()) {
    return router.createUrlTree(['/2fa']);
  }

  if (authService.hasPendingOtpSession()) {
    return router.createUrlTree(['/2fa']);
  }

  return true;
};
